import React, {Component} from 'react';
import PropTypes from "prop-types";
import StaticFunctions from "./StaticFunctions";

class TextAreaField extends Component {

    static propTypes = {
        name: PropTypes.string.isRequired,
    };

    static defaultProps = {
        type: 'text',
        className: 'textAreaField',
        value: '',
        autoFocus: false,
        isRequired: false,
        disabled: false,
        inValidClass: 'error',
        validate: null,
        minLength: 0,
        onFocus: () => {},
        onBlur: () => {},
        onChange: () => {},
        onKeyDown: () => {},
    };

    constructor(props) {

        super(props);

        this.state = {
            valid: true,
            value: (props.value) ? props.value : '',
            resetValue: props.value,
            hasBeenFocused: false,
        };

        this.setType = this.setType.bind(this);
        this.setValid = this.setValid.bind(this);

        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onValueChange = this.onValueChange.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);

        this.validate = this.validate.bind(this);

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.value !== this.props.value) {
            this.setState({
                value: nextProps.value,
                resetValue: nextProps.value,
            });
        }

    }

    setType() {

        const type = this.props.type;

        return (type === 'email') ? 'text' : type;

    }

    setValid(valid) {

        if (valid !== this.state.valid) {
            this.setState({
                valid: (valid === true)
            });
        }

    }

    onFocus() {

        this.setState({
            hasBeenFocused: true,
        });

    }

    onBlur() {

        this.validate();

    }

    onValueChange(event) {

        if (!this.props.disabled) {
            const value = event.target.value;

            this.setState({
                value,
            });
        }

    }

    onKeyDown(event) {

        if (event.keyCode === 13) {
            this.validate();
        } else if (event.keyCode === 27) {
            this.props.onKeyDown(this.props.name, this.state.resetValue, true);

            this.setState({
                value: this.state.resetValue
            });
        }

    }

    validate(init = false) {

        let valid = true;

        if (this.state.hasBeenFocused) {
            if (this.props.isRequired && this.state.value === '') valid = false;

            if (this.props.validate) {
                valid = this.props.validate(this.state.value);
            }

            if (!init) this.setValid(valid);
        }

        return valid;

    }

    render() {

        const {value, isRequired, inValidClass, validate, minLength, ...textAreaProps} = {...this.props};
        const valid = this.validate(true);

        textAreaProps.type = this.setType();
        textAreaProps.className = [this.props.className, (!valid) ? this.props.inValidClass : ''].join(' ').trim();

        return (
            <textarea {...textAreaProps}
                   value={this.state.value}
                   onFocus={(event) => {
                       this.onFocus();
                       textAreaProps.onFocus(event, this.props.name, event.target.value, valid);
                   }}
                   onBlur={(event) => {
                       this.onBlur();
                       textAreaProps.onBlur(event, this.props.name, event.target.value, valid);
                   }}
                   onChange={(event) => {
                       this.onValueChange(event);
                       textAreaProps.onChange(event, this.props.name, event.target.value, valid);
                   }}
                   onKeyDown={(event) => {
                       this.onKeyDown(event);
                       textAreaProps.onKeyDown(event, this.props.name, event.target.value, valid);
                   }}
            />
        );

    }

}

export default TextAreaField;